import { useSale } from '../../../../hooks/sale/useSale';

import POSDateField from '../../../POS/Fields/POSDateField';
import POSInputField from '../../../POS/Fields/POSInputField';

const POSCreditDaysSection = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================
  const { form, updateField } = useSale();

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        mt-4

        rounded-lg
        border
        border-stroke

        bg-whiten

        p-4

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}
      <div className="space-y-4">
        {/* ===================================================== */}
        {/* 🔹 Due Date */}
        {/* ===================================================== */}
        <POSDateField
          name="paymentCondition.creditDueDate"
          label="Fecha límite"
          iconKey="calendar"
          value={form.paymentCondition?.creditDueDate || ''}
          onChange={(date) => {
            if (!form.saleDate) return;

            const start = new Date(form.saleDate);

            const end = new Date(date);

            const diffInDays = Math.ceil(
              (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
            );

            updateField('paymentCondition', {
              ...form.paymentCondition,

              creditDueDate: date,

              creditDays: diffInDays >= 0 ? diffInDays : 0,
            });
          }}
        />

        {/* ===================================================== */}
        {/* 🔹 Credit Days */}
        {/* ===================================================== */}
        <POSInputField
          name="paymentCondition.creditDays"
          label="Días de crédito"
          type="number"
          min={0}
          placeholder="Ej: 30"
          icon="calendar"
          value={form.paymentCondition?.creditDays ?? ''}
          onChange={(e) => {
            const value = e.target.value.trim();

            if (value === '') {
              updateField('paymentCondition', {
                ...form.paymentCondition,

                creditDays: undefined,

                creditDueDate: '',
              });

              return;
            }

            const days = Number(value);

            if (form.saleDate && !isNaN(days)) {
              const start = new Date(form.saleDate);

              const dueDate = new Date(start);

              dueDate.setDate(start.getDate() + days);

              updateField('paymentCondition', {
                ...form.paymentCondition,

                creditDays: days,

                creditDueDate: dueDate.toISOString().split('T')[0],
              });
            }
          }}
        />
      </div>
    </div>
  );
};

export default POSCreditDaysSection;
